const images = new Map<string, HTMLImageElement>();

export const getCachedImage = (src: string): HTMLImageElement | null =>
  images.get(src) ?? null;

export const loadImage = (src: string): Promise<HTMLImageElement> => {
  const cached = images.get(src);
  if (cached) return Promise.resolve(cached);
  return new Promise((resolve, reject) => {
    const img = new Image();
    // Pixels are read back from canvases these images are drawn on.
    img.crossOrigin = "anonymous";
    img.onload = () => {
      images.set(src, img);
      resolve(img);
    };
    img.onerror = () => reject(new Error(`Could not load image ${src}`));
    img.src = src;
  });
};
